
import m from "mithril";
import { formatRupiah, formatDate } from "../utils.js";

const AkuntansiDashboard = {
    unpostedSavings: [],
    unpostedLoans: [],
    isLoading: true,
    error: "",

    oninit: async function () {
        await this.fetchUnpostedTransactions();
    },

    fetchUnpostedTransactions: async function () {
        this.isLoading = true;
        this.error = "";
        m.redraw();

        try {
            const response = await fetch('/api/accounting/unposted');
            const data = await response.json();

            if (data.success) {
                this.unpostedSavings = data.data.savings || [];
                this.unpostedLoans = data.data.loans || [];
            } else {
                this.error = data.message || "Failed to fetch data";
            }
        } catch (err) {
            console.error(err);
            this.error = "Network error";
        } finally {
            this.isLoading = false;
            m.redraw();
        }
    },

    view: function () {
        return m("div", { class: "p-6" }, [
            m("h1", { class: "text-2xl font-bold mb-6 text-gray-800 dark:text-white" }, "Dashboard Akuntansi"),

            // Error Message
            this.error ? m("div", { class: "bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" }, this.error) : null,

            // Loading State
            this.isLoading ? m("div", { class: "flex justify-center p-12" }, [
                m("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500" })
            ]) : m("div", { class: "grid grid-cols-1 lg:grid-cols-2 gap-6" }, [

                // Savings Card
                m("div", { class: "bg-white dark:bg-gray-800 rounded-lg shadow-md p-6" }, [
                    m("div", { class: "flex justify-between items-center mb-4" }, [
                        m("h2", { class: "text-xl font-semibold text-gray-700 dark:text-gray-200" }, [
                            m("i", { class: "ri-bank-line mr-2 text-green-500" }),
                            "Unposted Simpanan"
                        ]),
                        m("span", { class: "bg-green-100 text-green-800 text-xs font-semibold px-2.5 py-0.5 rounded dark:bg-green-200 dark:text-green-900" },
                            this.unpostedSavings.length
                        )
                    ]),

                    this.unpostedSavings.length === 0 ?
                        m("p", { class: "text-gray-500 italic" }, "Tidak ada transaksi simpanan yang belum diposting.") :
                        m("div", { class: "overflow-x-auto" }, [
                            m("table", { class: "min-w-full text-sm text-left text-gray-500 dark:text-gray-400" }, [
                                m("thead", { class: "text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" }, [
                                    m("tr", [
                                        m("th", { class: "px-4 py-2" }, "Tanggal"),
                                        m("th", { class: "px-4 py-2" }, "Nasabah"),
                                        m("th", { class: "px-4 py-2" }, "Jenis"),
                                        m("th", { class: "px-4 py-2 text-right" }, "Jumlah"),
                                    ])
                                ]),
                                m("tbody", this.unpostedSavings.map(item =>
                                    m("tr", { class: "bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600" }, [
                                        m("td", { class: "px-4 py-2" }, formatDate(item.date)),
                                        m("td", { class: "px-4 py-2" }, item.customer_name || "-"),
                                        m("td", { class: "px-4 py-2 capitalize" }, item.type),
                                        m("td", { class: "px-4 py-2 text-right font-medium text-gray-900 dark:text-white" }, formatRupiah(item.amount)),
                                    ])
                                ))
                            ])
                        ])
                ]),

                // Loans Card
                m("div", { class: "bg-white dark:bg-gray-800 rounded-lg shadow-md p-6" }, [
                    m("div", { class: "flex justify-between items-center mb-4" }, [
                        m("h2", { class: "text-xl font-semibold text-gray-700 dark:text-gray-200" }, [
                            m("i", { class: "ri-money-dollar-circle-line mr-2 text-blue-500" }),
                            "Unposted Angsuran"
                        ]),
                        m("span", { class: "bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded dark:bg-blue-200 dark:text-blue-800" },
                            this.unpostedLoans.length
                        )
                    ]),

                    this.unpostedLoans.length === 0 ?
                        m("p", { class: "text-gray-500 italic" }, "Tidak ada pembayaran angsuran yang belum diposting.") :
                        m("div", { class: "overflow-x-auto" }, [
                            m("table", { class: "min-w-full text-sm text-left text-gray-500 dark:text-gray-400" }, [
                                m("thead", { class: "text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" }, [
                                    m("tr", [
                                        m("th", { class: "px-4 py-2" }, "Tanggal"),
                                        m("th", { class: "px-4 py-2" }, "Nasabah"),
                                        m("th", { class: "px-4 py-2" }, "Metode"),
                                        m("th", { class: "px-4 py-2 text-right" }, "Jumlah"),
                                    ])
                                ]),
                                m("tbody", this.unpostedLoans.map(item =>
                                    m("tr", { class: "bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600" }, [
                                        m("td", { class: "px-4 py-2" }, formatDate(item.date)),
                                        m("td", { class: "px-4 py-2" }, item.customer_name || "-"),
                                        m("td", { class: "px-4 py-2" }, item.method),
                                        m("td", { class: "px-4 py-2 text-right font-medium text-gray-900 dark:text-white" }, formatRupiah(item.amount)),
                                    ])
                                ))
                            ])
                        ])
                ])
            ])
        ]);
    }
};

export default AkuntansiDashboard;
